module.exports = __webpack_public_path__ + "img/icon-office_atm.48ec7b31.svg";